/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/**
 * DE21 SEO: Klaviyo signup forms can inject their promotional heading as an H1.
 * Collection/product pages already have their own primary H1, so downgrade only
 * Klaviyo H1 elements to H2 while preserving styling and content.
 */
(function () {
  'use strict';

  function downgradeKlaviyoH1(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var headings = scope.querySelectorAll('h1');

    headings.forEach(function (heading) {
      var text = (heading.textContent || '').trim();
      var klaviyoAncestor = heading.closest('[class*="klaviyo" i], [id*="klaviyo" i]');
      var knownSignupHeading = text === 'Jetzt 10% sparen!';

      if (!klaviyoAncestor && !knownSignupHeading) {
        return;
      }

      var replacement = document.createElement('h2');

      Array.prototype.forEach.call(heading.attributes, function (attribute) {
        replacement.setAttribute(attribute.name, attribute.value);
      });

      if (replacement.hasAttribute('aria-level')) {
        replacement.setAttribute('aria-level', '2');
      }

      while (heading.firstChild) {
        replacement.appendChild(heading.firstChild);
      }

      heading.replaceWith(replacement);
    });
  }

  function initKlaviyoHeadingCleanup() {
    downgradeKlaviyoH1(document);

    if (!document.body) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) {
            return;
          }

          if (node.matches && node.matches('h1')) {
            var text = (node.textContent || '').trim();
            var klaviyoAncestor = node.closest('[class*="klaviyo" i], [id*="klaviyo" i]');
            if (klaviyoAncestor || text === 'Jetzt 10% sparen!') {
              downgradeKlaviyoH1(node.parentNode || document);
              return;
            }
          }

          downgradeKlaviyoH1(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlaviyoHeadingCleanup, { once: true });
  } else {
    initKlaviyoHeadingCleanup();
  }
})();
